module.exports = __webpack_public_path__ + "img/alert-white.a5006122.svg";